import {AxiosError} from 'axios';

/**
 * The message to show for a failed request, preferring the one the server
 * sent. `fallback` is used when the error carries no message, or the server's
 * message is empty.
 */
export const getErrorMessage = (error: unknown, fallback = 'Unknown error') => {
  if (error instanceof AxiosError) {
    const serverMessage: unknown = error.response?.data?.errorMessage;
    if (typeof serverMessage === 'string') {
      return serverMessage || fallback;
    }
    return error.message;
  }
  if (
    typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    typeof error.message === 'string'
  ) {
    return error.message || fallback;
  }
  return fallback;
};
